import {
  Button,
  Flex,
  IconButton,
  Input,
  Menu,
  MenuButton,
  MenuGroup,
  MenuItem,
  MenuList,
  RangeSlider,
  RangeSliderFilledTrack,
  RangeSliderThumb,
  RangeSliderTrack,
  Text,
} from "@chakra-ui/react";
import moment from "moment";
import { useState } from "react";
import { NumericFormat, PatternFormat } from "react-number-format";
import {
  BLUECARD,
  BLUEMONEDDBUTTONS,
  GRAY_LIGHTER,
  VARIANT,
  WHITE,
} from "../constants/colors";

export default function ValueDropdown({ filtros, setFiltros }: any) {
  const [valor, setValor] = useState({
    valor1: 0,
    valor2: 0,
  });

  const valorminimo = 0;
  const valormáximo = 50000;

  function changeValues(item: any) {
    setValor({ ...valor, valor1: item[0], valor2: item[1] });
    setFiltros({
      ...filtros,
      minValueFilter: item[0],
      maxValueFilter: item[1],
    });
  }

  async function Filtrar() {
    setFiltros({
      ...filtros,
      minValueFilter: valor.valor1,
      maxValueFilter: valor.valor2,
    });
  }

  return (
    <Menu closeOnSelect={false}>
      <MenuButton
        fontSize={"0.8vw"}
        minWidth="100px"
        maxWidth={"100px"}
        bgColor={"white"}
        color="gray"
        h={"30px"}
        borderRadius={"20px"}
      >
        R$
      </MenuButton>
      <MenuList minWidth="300px">
        <MenuGroup title={"De"}>
          <MenuItem isDisabled={true}>
            <NumericFormat
              decimalSeparator=","
              decimalScale={2}
              customInput={Input}
              value={Number(filtros.minValueFilter)}
              onChange={(e: any) => {
                setValor({
                  ...valor,
                  valor1: Number(e.target.value.replace(",", ".")),
                });
              }}
            />
          </MenuItem>
        </MenuGroup>
        <MenuGroup title={"Até "}>
          <MenuItem isDisabled={true}>
            <NumericFormat
              decimalSeparator=","
              decimalScale={2}
              customInput={Input}
              value={Number(filtros.maxValueFilter)}
              onChange={(e: any) => {
                setValor({
                  ...valor,
                  valor2: Number(e.target.value.replace(",", ".")),
                });
              }}
            />
          </MenuItem>
        </MenuGroup>

        <MenuItem>
          <Button bgColor={BLUECARD} color="white" w={"100%"} onClick={Filtrar}>
            Filtrar
          </Button>
        </MenuItem>
      </MenuList>
    </Menu>
  );
}
